import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { AccountingService } from '../../../services/accounting.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'invoice-model',
  templateUrl: './invoice-model.component.html',
  styleUrls: ['./invoice-model.component.scss']
})

export class InvoiceModelComponent implements OnInit {
  invoiceUrl: any;
  woInvoiceDetails: UntypedFormGroup;
  loading: any;

  onUpdate = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<InvoiceModelComponent>,
    @Inject(MAT_DIALOG_DATA) public woData: any,
    public dialog: MatDialog, public sanitizer: DomSanitizer, private formBuilder: UntypedFormBuilder,
    private accountingService: AccountingService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.woInvoiceDetails = this.formBuilder.group({
      ref_no: [''],
      po_number: [''],
      truck_number: [''],
      trailer_number: [''],
      odometer: [''],
      workorder_number: ['']
    });

    let url = this.accountingService.baseUrlForAccounting + "invoicebatch/createinvoicepdfajax/batchid/" + this.woData.woNumberdata.batchId + "/invoicewoid/" + this.woData.woNumberdata.wO + "#zoom=90";
    this.invoiceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.woInvoiceDetails.setValue({
      ref_no: this.woData.woNumberdata.refNo,
      po_number: this.woData.woNumberdata.pONumber,
      truck_number: this.woData.woNumberdata.truckNumber,
      trailer_number: this.woData.woNumberdata.trailerNumber,
      odometer: this.woData.woNumberdata.odometer,
      workorder_number: this.woData.woNumberdata.wO
    });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  updateWODetails() {
    this.loading = true;
    this.accountingService.updateWoDetailsOnInvoice(this.woInvoiceDetails.value).subscribe((response: any) => {
      if (response.status) {
        let url = this.accountingService.baseUrlForAccounting + "invoicebatch/createinvoicepdfajax/batchid/" + this.woData.woNumberdata.batchId + "/invoicewoid/" + this.woData.woNumberdata.wO + '/' + (new Date()).getTime() + "#zoom=90";
        this.invoiceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.loading = false;
        this.onUpdate.emit();
      }
    });
  }

}
